<div class="form-row">
  <div class="form-group col-md-4">
    <label for="inputEmail4">Start Date</label>
    <input type="date" name='name' [(ngModel)]='this.vehicleVOR.startDate' [class.is-invalid]='!this.vehicleVOR.startDate' class="form-control" id="inputEmail4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">End Date</label>
    <input type="date" name='registration' [(ngModel)]='this.vehicleVOR.endDate' [class.is-invalid]='!this.vehicleVOR.endDate'  class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="inputPassword4">Vehicle</label>
    <ng-select [(ngModel)]="this.vehicleVOR.vehicleId" class='form-control' [class.is-invalid]='this.vehicleVOR.vehicleId === -1' (change)='this.vehicleVOR.vehicleId = +$event; this.vehicleVOR.vehicle.id = this.vehicleVOR.vehicleId'>
      @for (item of this.vehicles; track item) {
        <ng-option [value]='item.id'>{{ item.registration }}</ng-option>
      }
    </ng-select>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label for="inputPassword4">Notes</label>
    <textarea name='notes' [(ngModel)]='this.vehicleVOR.notes' class="form-control"></textarea>
  </div>
</div>

<div class='form-row'>
  <div class="form-group col-md-6">
    <label for="overrideCode">Override code <small class='text-muted'>(optional)</small></label>
    <input type='text' name='overrideCode' [(ngModel)]='this.vehicleVOR.overrideCode' class="form-control" id="overrideCode" placeholder="Leave blank to allow no override">
  </div>
</div>
